import { Button } from "@mui/material";
import { TableColumn } from "react-data-table-component";

import { type CallScheduleInfoFragment } from "@/graphql/graphql";

/**
 * Sorts two cron expressions as follows:
 *
 * 1. Lexigrophically by days of week string, so "0" < "0,1,2" (Sunday, Monday, Tuesday). Special
 * case being * (all days of the week), which goes last (> than everything else)
 * 2. Then by hour
 * 3. Then by minute
 */
export const sortCrons = (cronA: string, cronB: string): number => {
  const partsA = (cronA || "").split(" ");
  const partsB = (cronB || "").split(" ");

  if (partsA.length < 5 || partsB.length < 5) {
    return (cronA || "").localeCompare(cronB || "");
  }

  const daysA = partsA[4];
  const daysB = partsB[4];
  // Special case: * (all days of the week) goes last (> than everything else)
  if (daysA === "*" && daysB !== "*") {
    return 1;
  }
  if (daysB === "*" && daysA !== "*") {
    return -1;
  }
  const dayComparison = daysA.localeCompare(daysB);
  if (dayComparison !== 0) {
    return dayComparison;
  }

  const hourA = parseInt(partsA[1], 10);
  const hourB = parseInt(partsB[1], 10);
  if (hourA !== hourB) {
    return hourA - hourB;
  }

  const minA = parseInt(partsA[0], 10);
  const minB = parseInt(partsB[0], 10);
  return minA - minB;
};

const COMMON_COLUMNS: TableColumn<CallScheduleInfoFragment>[] = [
  {
    cell: (row) => row.scheduleDescription,
    wrap: true,
  },
];

export const getCallScheduleColumns = (
  onDeleteClick: (id: number) => void
): TableColumn<CallScheduleInfoFragment>[] => [
  ...COMMON_COLUMNS,
  {
    cell: (row) => <Button onClick={() => onDeleteClick(row.id)}>Delete</Button>,
    button: true,
  },
];

export const getDeletedCallScheduleColumns = (
  onRestoreClick: (id: number) => void
): TableColumn<CallScheduleInfoFragment>[] => [
  ...COMMON_COLUMNS,
  {
    cell: (row) => <Button onClick={() => onRestoreClick(row.id)}>Restore</Button>,
    button: true,
  },
];
